import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const PARTNER_API = `${BACKEND_URL}/api`;

/**
 * Separate axios instance for the Partner Agency portal.
 * Keeps the partner JWT completely isolated from the admin token
 * so an admin logged in on the same browser can also test the partner
 * portal without token collisions.
 */
export const partnerApi = axios.create({ baseURL: PARTNER_API });

partnerApi.interceptors.request.use((config) => {
  const token = localStorage.getItem("partner_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Any 401/403 inside /partner routes → bounce to login
partnerApi.interceptors.response.use(
  (r) => r,
  (err) => {
    const status = err?.response?.status;
    if ((status === 401 || status === 403) && window.location.pathname.startsWith("/partner")) {
      localStorage.removeItem("partner_token");
      localStorage.removeItem("partner_agency");
      if (!window.location.pathname.startsWith("/partner/login")) {
        window.location.href = "/partner/login?expired=1";
      }
    }
    return Promise.reject(err);
  }
);

export const setPartnerToken = (token, agencyName) => {
  if (token) {
    localStorage.setItem("partner_token", token);
    if (agencyName) localStorage.setItem("partner_agency", agencyName);
  } else {
    localStorage.removeItem("partner_token");
    localStorage.removeItem("partner_agency");
  }
};

export const getPartnerToken = () => localStorage.getItem("partner_token");
export const getPartnerAgency = () => localStorage.getItem("partner_agency") || "";
